import type { LucideIcon } from 'lucide-react'
import {
	type I18nKeys,
	useTranslation,
} from '@/shared/core/hooks/use-translation/use-translation.ts'
import '@/teams/portfolio/components/section/home-section/ai-indicator/info-card/info-card.scss'

interface InfoCardProps {
	className?: string
	icon?: LucideIcon
	titleKey: I18nKeys
	valueKey: I18nKeys
}

export function InfoCard({
	titleKey,
	valueKey,
	icon: Icon,
	className,
}: Readonly<InfoCardProps>) {
	const { t } = useTranslation()
	const classes = ['info-card', className].filter(Boolean).join(' ')

	return (
		<div className={classes} data-testid='info-card'>
			{Icon && (
				<div className='info-card__icon-wrapper'>
					<Icon aria-hidden='true' className='info-card__icon' />
				</div>
			)}
			<div className='info-card__content'>
				<h3 className='info-card__title'>{t(titleKey)}</h3>
				<p className='info-card__value'>{t(valueKey)}</p>
			</div>
		</div>
	)
}
